// Provider-verified refund state — "complete" only after the payment provider confirms it.
const LABEL = { PENDING: "Refund pending", SUCCEEDED: "Refund complete", FAILED: "Refund failed" };
const CLS = { PENDING: "badge-reserved", SUCCEEDED: "badge-available", FAILED: "badge-sold" };

export const RefundStatus = ({ order, admin = false }) => {
  const r = order?.refund;
  const st = r?.status || (order?.status === "REFUND_INITIATED" ? "PENDING" : null);
  if (!st) return null;
  const amount = r?.confirmed_total_usd ?? r?.total_usd;
  return (
    <div className="mt-4 rounded-md border border-border bg-white p-4 text-xs" data-testid="refund-status-panel">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`badge-status ${CLS[st] || "badge-neutral"}`} data-testid="refund-status-badge">{LABEL[st] || st}</span>
        {amount != null && <span className="num text-charcoal" data-testid="refund-status-amount">${Number(amount).toFixed(2)}</span>}
        {r?.verified_at && <span className="text-warmgrey" data-testid="refund-status-verified">verified with payment provider {new Date(r.verified_at).toLocaleString()}</span>}
      </div>
      <p className="mt-1 text-warmgrey" data-testid="refund-status-note">
        {st === "PENDING" && "The order is locked while the payment provider processes the refund."}
        {st === "SUCCEEDED" && "Confirmed by the payment provider."}
        {st === "FAILED" && (admin ? "The provider reported a failure — retry the refund or resolve it manually." : "The provider could not complete the refund — Zelligio will follow up.")}
      </p>
      {admin && (r?.items || []).map((it) => (
        <span key={it.stripe_refund_id} className="mt-1 block font-mono text-warmgrey" data-testid={`refund-item-${it.stripe_refund_id}`}>{it.stripe_refund_id} · ${Number(it.amount_usd).toFixed(2)} · {it.status}</span>
      ))}
    </div>
  );
};
